"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _LoadingOutlined2 = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/LoadingOutlined.svg"));
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _devConsoleLog = require("../_util/devConsoleLog");
var _insertRipple = _interopRequireDefault(require("../_util/insertRipple"));
var _utils = require("../_util/utils");
var _explain = _interopRequireDefault(require("../explain"));
var _icon = _interopRequireDefault(require("../icon"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const checkChildren = Element => {
  if (! /*#__PURE__*/_react.default.isValidElement(Element)
  // || (Element.type as any).name !== Select.name
  ) {
    (0, _devConsoleLog.error)(true, 'TextField', 'The "TextField" children error.');
    return false;
  }
  return true;
};
const TextField = props => {
  const {
    label,
    type,
    shrink,
    isFocus,
    size,
    disabled,
    loading,
    error,
    readonly,
    mText,
    prefix,
    suffix,
    style,
    width,
    wrapClassName,
    className,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    children,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-textField");
  const attrs = (0, _utils.pickDomAttrs)(restProps);

  // errorConsoleLog(
  //   type === 'filled' && size === 's',
  //   'Select',
  //   'When type is "filled", "size" does not have the "s" attribute.'
  // );

  const child = (0, _react.useMemo)(() => {
    return checkChildren(children) ? /*#__PURE__*/_react.default.cloneElement(children, {
      className: (0, _classnames.default)(children.props.className, "".concat(baseClassName, "-content"))
    }) : null;
  }, [children]);
  const prefixIcon = (0, _react.useMemo)(() => {
    return prefix ? /*#__PURE__*/_react.default.cloneElement(prefix, {
      className: (0, _classnames.default)(prefix.props.className, "".concat(baseClassName, "-prefixIcon"), {
        mText
      })
    }) : null;
  }, [prefix, mText]);
  const suffixIcon = (0, _react.useMemo)(() => {
    if (loading) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: (0, _classnames.default)("".concat(baseClassName, "-suffixIcon"), {
          mText
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "LoadingOutlined",
          style: {
            display: 'block'
          }
        })
      });
    }
    return suffix ? /*#__PURE__*/_react.default.cloneElement(suffix, {
      className: (0, _classnames.default)(suffix.props.className, "".concat(baseClassName, "-suffixIcon"), {
        mText
      })
    }) : null;
  }, [suffix, loading, mText]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_explain.default, {
    ...attrs.data,
    helperText: error === true ? undefined : error,
    wrapClassName: wrapClassName,
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classnames.default)(baseClassName, className, {
        ["".concat(baseClassName, "-").concat(type)]: !!type,
        ["".concat(baseClassName, "-shrink")]: shrink,
        ["".concat(baseClassName, "-").concat(size)]: !!size,
        ["".concat(baseClassName, "-focus")]: isFocus,
        ["".concat(baseClassName, "-disabled")]: !!disabled,
        ["".concat(baseClassName, "-error")]: !!error,
        ["".concat(baseClassName, "-loading")]: !!loading,
        ["".concat(baseClassName, "-readonly")]: !!readonly,
        ["".concat(baseClassName, "-with-prefixIcon")]: !!prefixIcon,
        ["".concat(baseClassName, "-with-suffixIcon")]: !!suffixIcon
      }),
      ref: ref => {
        (0, _insertRipple.default)({
          className: "".concat(prefixClass, "-ripple"),
          ref
        });
      },
      style: {
        width,
        height: mText ? 'auto' : undefined,
        minHeight: mText,
        ...style
      },
      children: [prefixIcon, suffixIcon, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: (0, _classnames.default)("".concat(baseClassName, "-border")),
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames.default)("".concat(baseClassName, "-border-leading"))
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames.default)("".concat(baseClassName, "-border-notch")),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
            className: (0, _classnames.default)("".concat(baseClassName, "-label"), {
              mText
            }),
            children: label
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: (0, _classnames.default)("".concat(baseClassName, "-border-trailing"))
        })]
      }), child]
    })
  });
};
var _default = exports.default = TextField;